module.exports = __webpack_public_path__ + "static/concept3-sp-7326a54b66e7bea0c43683a67a0225a3.svg";